const Label = (props: { text: string }) => {
  return <div className="inline-block w-max py-1 px-2 leading-none text-center whitespace-nowrap text-xxs bg-badge-bg text-badge font-normal tracking-wide rounded">{props.text}</div>
}

export default Label;